export default __webpack_public_path__ + "public/icons/traceabilityReportPageCover.svg?eedfa3a1af1c8518a54e2ef190bbefec";